import AddressComponent from './AddressComponent'

const Address = {
    install:function (Vue) {
        Vue.component('Address',AddressComponent)
    }
}
export default Address


// WEBPACK FOOTER //
// ./src/components/components/Address/index.js